<ng-container *ngIf="initComplete">
  <div class="saved-grids-list-panel">
    <nf-checkbox
      *ngFor="let advanceControl of advanceControlMap"
      [formControl]="advanceControl.control"
      label="{{ advanceControl.label }}"
    ></nf-checkbox>
  </div>
</ng-container>
